import getTheme from "./getTheme";
export default function radius(radius, theme) {
    return getTheme(theme).radius[radius];
}
//# sourceMappingURL=radius.js.map